import React, { useState, useMemo } from "react";
import { motion } from "framer-motion";
import {
  Container,
  Wrapper,
  Title,
  Desc,
  CardContainer,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
} from "./ProjectsStyle";
import ProjectCard from "../Cards/ProjectCards";
import { projects } from "../../data/constants";
import { fadeUpVariants, staggerContainer } from "../../App";

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState("all");

  // Filter projects based on toggle
  const filteredProjects = useMemo(() => {
    if (toggle === "all") {
      return projects;
    }
    return projects.filter((project) => project.category === toggle);
  }, [toggle]);

  return (
    <Container id="projects">
      <Wrapper
        as={motion.div}
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.05 }}
      >
        <motion.div variants={fadeUpVariants}>
          <Title>Projects</Title>
        </motion.div>
        <motion.div variants={fadeUpVariants}>
          <Desc>
            I have worked on a wide range of projects. From web apps to android
            apps. Here are some of my projects.
          </Desc>
        </motion.div>
        <motion.div variants={fadeUpVariants}>
          <ToggleButtonGroup>
            <ToggleButton
              active={toggle === "all"}
              onClick={() => setToggle("all")}
            >
              All
            </ToggleButton>
            <Divider />
            <ToggleButton
              active={toggle === "web app"}
              onClick={() => setToggle("web app")}
            >
              WEB APP'S
            </ToggleButton>
            <Divider />
            <ToggleButton
              active={toggle === "android app"}
              onClick={() => setToggle("android app")}
            >
              ANDROID APP'S
            </ToggleButton>
            <Divider />
            <ToggleButton
              active={toggle === "chrome-extension"}
              onClick={() => setToggle("chrome-extension")}
            >
              CHROME EXTENSION
            </ToggleButton>
          </ToggleButtonGroup>
        </motion.div>
        <CardContainer>
          {toggle === "chrome-extension" ? (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '60px 20px',
                width: '100%',
                textAlign: 'center',
              }}
            >
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>🚀</div>
              <h3 style={{
                fontSize: '24px',
                fontWeight: '600',
                color: '#854CE6',
                marginBottom: '12px',
              }}>Coming Soon!</h3>
              <p style={{
                fontSize: '16px',
                color: 'rgba(255, 255, 255, 0.7)',
                maxWidth: '400px',
              }}>Chrome extensions are in development. Stay tuned for exciting updates!</p>
            </motion.div>
          ) : (
            filteredProjects.map((project) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                <ProjectCard
                  project={project}
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                />
              </motion.div>
            ))
          )}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;
